import React from "react";
import { Link } from "react-router-dom";
import ProfileIcon from "components/util/helpers/ProfileIcon";
import FlowFormCreate from "components/presentation/forms/flows/FlowFormCreate"
import l from "components/util/l";


const InitialView = () => (
  <div id="presentation-mode" className="d-flex">
    <div id="presentation-container" className="h-100 w-100">
      <div id="presentation-header"
        className={"d-flex w-100 justify-content-between align-items-center"}>
          <div id="presentation-title" class="d-flex align-items-center"></div>
        <div id="presentation-actions" className="d-flex">

          <span className="d-flex align-items-center">

            <div class="dropdown">
              <div className="profile-button dropdown-toggle d-none"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <ProfileIcon style={{ width: "100%", height: "100%" }} />
              </div>

              <div class="dropdown-menu pr-1">
                <Link to={`/settings/account`} class="dropdown-item">
                  <i class="fas fa-user dropdown-item-icon mr-1"></i> {l("Perfil")}
                </Link>
                <Link to={`/settings/plan`} class="dropdown-item">
                  <i class="fas fa-money-bill dropdown-item-icon mr-1"></i> {l("Plan y facturación")}
                </Link>
                <Link to={`/settings/flows`} class="dropdown-item">
                  <i class="fas fa-layer-group dropdown-item-icon mr-1"></i> {l("Soluciones")}
                </Link>

                <hr className="my-2" />
                <Link to={`/settings/customization`} class="dropdown-item">
                  <i class="fas fa-cog dropdown-item-icon mr-1"></i> {l("Ajustes")}
                </Link>
                <a href={`/logout`} class="dropdown-item">
                  <i class="fas fa-sign-out dropdown-item-icon mr-1"></i> {l("Cerrar sesión")}
                </a>
              </div>

            </div>
          </span>

        </div>
      </div>
      <div id="presentation-content" className="pb-8">
        <div className="section-container">
          <div className="my-5">
            <FlowFormCreate />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default InitialView;